export default "__VITE_ASSET__DDyR5Ews__"